module.exports = __webpack_public_path__ + "assets/restaurant_type-30088f.svg";